import {
    SpotlightWaitlistConstants,
    getMixtureConfig
   } from '../View/exportComponent';

const MIXTURE_CONFIG= getMixtureConfig();
const mixtureParticipationAPI = process.env.MIXTURE_CHAMPAIGN_PARTICIPATION;
const mixtureLocale = process.env.MIXTURE_CAMPAIGN_LOCALE;
const mixtureTraitIdValue = process.env.MIXTURE_TRAIT_ID_VALUE;
const mixtureTraitSource = process.env.MIXTURE_TRAIT_SOURCE;
const mixtureEmailIdOptin = process.env.MIXTURE_OPTIN_ID_EMAIL;
const mixtureUpdateTraitAPI = process.env.MIXTURE_UPDATE_TRAIT_API;
const mixtureDoubleOptin = process.env.MIXTURE_DOUBLE_OPTIN;
const mixtureDoubleOptinLegalEntity= process.env.MIXTURE_DOUBLE_OPTIN_LEGAL_ENTITY_NUMBER;
const mixtureDoubleOptinOptNumber = process.env.MIXTURE_DOUBLE_OPTIN_OPT_NUMBER;
const mixtureDoubleOptinChannelIndicator = process.env.MIXTURE_DOUBLE_OPTIN_CHANNEL_INDICATOR;
const mixtureDoubleOptinContactCategory = process.env.MIXTURE_DOUBLE_OPTIN_CONTACT_CATEGORY;
const mixtureDoubleOptinContactType = process.env.MIXTURE_DOUBLE_OPTIN_CONATACT_TYPE;
const mixtureDoubleOptinOptVersion = process.env.MIXTURE_DOUBLE_OPTIN_OPT_VERSION;
const mixtureChannelId = process.env.MIXTURE_CHANNEL_ID;

function handleTraitsId(traitsData, mixtureTraitValue, mixtureTraitName) {
    let traitValue = mixtureTraitValue;
    let traitsObj = traitsData.filter((item) => item.trait.id === String(mixtureTraitValue));
    if(traitsObj.length > 0) {
        traitValue = traitsObj?.[0]?.trait?.id;
    } else {
        traitsObj = traitsData.filter((item) => item.trait.name === mixtureTraitName);
        if(traitsObj.length > 0) {
            traitValue = traitsObj?.[0]?.trait?.id;
        }
    }
    return traitValue;
}


function handleOptinId(optinsData, mixtureOptinId) {
    let optinId = mixtureOptinId;
    let optinObj = optinsData.filter((item) => item.optIn.id === String(mixtureOptinId));
    if(optinObj.length > 0) {
        optinId = optinObj?.[0]?.optIn?.id;
    }
    return optinId;
}

function removeTags(htmlContent) {
   return htmlContent?.replace( /(<([^>]+)>)/ig, '') || '';
}

function mixtureFormUpdateTraitsPayload(traitsValue) {
    const body = {};

    body['traits'] = [
        {
            "traitId": mixtureTraitIdValue,
            "value": (traitsValue) ? [traitsValue] : ['']
        }
    ];

    return body;
}

function mixtureDoubleOptinPayload(verificationCode, optinText) {
    const body = {
        "verificationCode": verificationCode,
        "legalEntityNumber": mixtureDoubleOptinLegalEntity,
        "optNumber": mixtureDoubleOptinOptNumber,
        "optId": mixtureEmailIdOptin,
        "optText": removeTags(optinText),
        "optServiceName": SpotlightWaitlistConstants.doubleOptinServiceName,
        "channelIndicator": mixtureDoubleOptinChannelIndicator,
        "contactCategory": mixtureDoubleOptinContactCategory,
        "contactType": mixtureDoubleOptinContactType,
        "optVersion": mixtureDoubleOptinOptVersion
      }

    return body;
}

function mixtureFormRegisterPayload(firstName, email, hasAcceptedTermsAndConditions, selectedBrushType, traitsData, optinsData, legalText, campaignTraitValue, abTestValue, mode) {
    let body = {};
    body.campaign = {
        'campaignId': Number(MIXTURE_CONFIG[mode]['MIXTURE_CHAMPAIGN_ID']),
        'locale': mixtureLocale
    };

    body.consumer = {
        'email': email
    };
    
    body.traits = [
        {
            'traitId': handleTraitsId(traitsData, mixtureTraitSource, SpotlightWaitlistConstants.transmitterSource),
            'value': [campaignTraitValue]
        }
    ];

    if(firstName) {
        body.consumer['firstName'] = firstName
    }

    if(selectedBrushType) {
        body.traits.push({
            'traitId': handleTraitsId(traitsData, mixtureTraitIdValue, SpotlightWaitlistConstants.traitBrushTechnologyIdValue),
            'value': [selectedBrushType?.split(',')?.[0]]
        })
    }

    if(hasAcceptedTermsAndConditions) {
        body.optIns = [
            {
                'optinId': handleOptinId(optinsData, mixtureEmailIdOptin),
                'optinText': removeTags(legalText)
            }
        ];
    }

    // if(abTestValue) {
    //     body.additionalParameters = {
    //         'ExperimentVariant': abTestValue,
    //     }
    // }
    return body;
}

export const mixtureFormRegister = async ({firstName, email, hasAcceptedTermsAndConditions, selectedBrushType, traitsData, optinsData, legalText, campaignTraitValue, abTestValue, mode}) => {
    try {
        const body = mixtureFormRegisterPayload(firstName, email, hasAcceptedTermsAndConditions, selectedBrushType, traitsData, optinsData, legalText, campaignTraitValue, abTestValue, mode);
        const response = await fetch(mixtureParticipationAPI, {
            method: "POST",
            headers: { 
                "Content-Type": "application/json",
                "channelId": mixtureChannelId
            },
            body: JSON.stringify(body)
          });
          
        if(!response.ok) {
            return response;
        }
        const data = await response.json();
        return data;        
    } catch (error) {
        throw error;
    }    
}

export const updateTraitsMixtureFormRegister = async ({ traitsValue, participationID, mode }) => {
    try {
        const body = mixtureFormUpdateTraitsPayload(traitsValue);
        const url = mixtureUpdateTraitAPI + '/' + participationID + '/traits'
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "channelId": mixtureChannelId
            },
            body: JSON.stringify(body)
        });

        if (!response.ok) {
            return response;
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw error;
    }
}


export const sendDoubleOptin = async ({ verificationCode, optinText }) => {
    try {
        const body = mixtureDoubleOptinPayload(verificationCode, optinText);
        const response = await fetch(mixtureDoubleOptin, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "channelId": mixtureChannelId
            },
            body: JSON.stringify(body)
        });

        if (!response.ok) {
            return response;
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw error;
    }
}